// removed by extract-text-webpack-plugin
module.exports = {"container":"_1NtxSD3","container__column":"_26_yujQ","item":"_2uD85Ca","label":"_3ORur7s","label__dark":"_30YKIbT","label__light":"_16EFHZ4","image":"_2PBH9Tw","thumbnail":"zgb64R9","vertical":"_2_fWyUH","light":"_3RbcbtV","dark":"_2Qt4a5S","horizontal":"_3t_t-Xe"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css
// module id = ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css
// module chunks = client.sitechrome